import { motionValue } from 'framer-motion';
import { createContext, createRef, useContext } from 'react';
const ParallaxRangeContext = createContext({
    progress: motionValue(0),
    outerProgress: motionValue(0),
    scrollProgressRef: createRef(),
});
export default ParallaxRangeContext;
export const useParallaxRange = () => useContext(ParallaxRangeContext);
